// extracted by mini-css-extract-plugin
module.exports = {"text":"text__4wZSS","loading":"loading__NvrdD","icon":"icon__xinRK","button-loader":"button-loader__dw8Gi"};